import { gql } from '@apollo/client';
import { NoteFragments } from '../../fragments/note/note.fragments';

export const GET_LEADERS = gql`
  query getLeadersNat($tableau: String) {
    getClassement(tableau: $tableau) {
      ...Rank
    }
  }
  ${NoteFragments.fragments.Rank}
`;

//Todo requête à optimiser en backend
export const GET_POSITIONS = gql`
  query getPositions {
    myPositions: getMyPositions {
      niveauRank
      classeRank
      academieRank
      nationalRank
    }
  }
`;
